<template>
  <div>
    <b-form-group
      :label="$t('reusable.common.name')"
      label-for="input-name"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <b-form-input
        id="input-name"
        name="input-name"
        v-model="$v.matter_category.name.$model"
        :state="validateState('name')"
        aria-describedby="input-name-live-feedback"
        size="sm"
      ></b-form-input>
      <b-form-invalid-feedback id="input-name-live-feedback">{{
        $t("reusable.common.minLength", { min: 2 })
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="$t('reusable.common.description')"
      label-for="input-description"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <div
        class="matter_category-description mr-0 mt-1"
        @click="
          $bvModal.show(
            `edit-matter_category-description-modal-${matter_category.id}`
          )
        "
      >
        <RenderVHtml
          v-b-tooltip.v-secondary.noninteractive.hover="{
            title: $t('reusable.common.editDescription'),
            boundary: 'viewport',
          }"
          :content="matter_category.description"
        ></RenderVHtml>
      </div>
      <ContainerRichTextKlv3
        :id_modal="`edit-matter_category-description-modal-${matter_category.id}`"
        :title_modal="$t('reusable.common.editDescription')"
        :size_modal="`lg`"
        :object_rich_text="matter_category"
        :content_rich_text="matter_category.description"
        :show_last_modification="true"
        :permit_blank="true"
        @save="(content) => patchMatterCategory(matter_category, content)"
        @close="
          $bvModal.hide(
            `edit-matter_category-description-modal-${matter_category.id}`
          )
        "
      >
      </ContainerRichTextKlv3>
      <!-- <b-modal
        :id="`edit-matter_category-description-modal-${matter_category.id}`"
        title="Editar Descripción"
        size="lg"
        hide-footer
      >
        <NewRichTextEditor
          :Object="matter_category"
          :Text="matter_category.description"
          :permit_blank="true"
          @save="patchMatterCategory"
          @close="
            $bvModal.hide(
              `edit-matter_category-description-modal-${matter_category.id}`
            )
          "
        ></NewRichTextEditor>
      </b-modal> -->
    </b-form-group>
    <b-form-group
      v-if="!isNaN(this.matter_category.id)"
      label-for="input-modification-date"
      label-cols="0"
      label-cols-sm="0"
      class="p-0 m-0 mt-2"
    >
      <ModificationDate :Information="matter_category"></ModificationDate>
    </b-form-group>
    <div class="row">
      <div
        v-if="show_delete_button && !isNaN(this.matter_category.id)"
        class="col"
        style="text-align: left"
      >
        <b-button
          class="mr-1"
          size="sm"
          variant="danger"
          @click="deleteMatterCategory"
          >{{ $t("reusable.common.delete") }}</b-button
        >
      </div>
      <div v-if="show_save_button" class="col" style="text-align: right">
        <b-button class="m-0" size="sm" @click="save">{{
          $t("reusable.common.save")
        }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { generateUniqueId } from "@/utils/utils";
import * as names from "@/store/names";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { toast } from "@/utils/utils";
import { mapGetters } from "vuex";
export default {
  name: "MatterCategoryForm",
  mixins: [validationMixin],
  components: {
    // NewRichTextEditor: () => import("@/components/reusable/NewRichTextEditor"),
    ModificationDate: () => import("@/components/reusable/ModificationDate"),
    ContainerRichTextKlv3: () =>
      import("@/components/reusable/ContainerRichTextKlv3"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
  },
  props: {
    MatterCategory: {
      type: Object,
      default: function () {
        return {
          id: generateUniqueId(),
          name: "",
          description: "",
          creation_date: null,
          created_by: null,
          updated_by: null,
          update_date: null,
        };
      },
    },
    show_save_button: {
      type: Boolean,
      default: true,
    },
    show_delete_button: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      matter_category: { ...this.MatterCategory },
    };
  },
  validations: {
    matter_category: {
      name: {
        required,
        minLength: minLength(2),
      },
      description: {
        minLength: minLength(0),
      },
    },
  },
  computed: {
    ...mapGetters({
      institution: "getInstitution",
    }),
  },
  created() {},
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.matter_category[name];
      return $dirty ? !$error : null;
    },
    patchMatterCategory(object, text) {
      this.matter_category.description = text;
    },
    save() {
      this.$v.matter_category.$touch();
      if (this.$v.matter_category.$anyError) {
        return;
      }
      if (isNaN(this.matter_category.id)) {
        this.createMatterCategory();
      } else this.updateMatterCategory();
    },
    createMatterCategory() {
      this.$store
        .dispatch(names.POST_MATTER_CATEGORY, this.matter_category)
        .then((response) => {
          toast(
            this.$getVisibleNames(
              "teaching.mattercategory",
              false,
              "Categoría"
            ) +
              " " +
              this.$t("reusable.common.created")
          );
          this.$emit("created", response);
        });
    },
    updateMatterCategory() {
      this.$store
        .dispatch(names.UPDATE_MATTER_CATEGORY, this.matter_category)
        .then((response) => {
          toast(
            this.$getVisibleNames(
              "teaching.mattercategory",
              false,
              "Categoría"
            ) +
              " " +
              this.$t("reusable.common.updated")
          );
          this.$emit("updated", response);
        });
    },
    deleteMatterCategory() {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "teaching.mattercategory",
            false,
            "Categoría"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch(
            names.DELETE_MATTER_CATEGORY,
            this.matter_category.id
          );
          this.$emit("deleted", this.matter_category);
        }
      });
    },
  },
};
</script>
<style scoped src="@/utils/rich_text_editor.css">
</style>
<style scoped>
.matter_category-description {
  width: calc(100%);
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 0.875rem;
  min-height: calc(1.5em + 0.5rem + 2px);
  max-height: 10em;
  overflow-y: auto;
  padding: 0.25rem 1.2rem;
  line-height: 1.5;
}
.matter_category-description >>> p {
  margin-bottom: 0.7rem !important;
}
</style>